"use client";

import { c as _c } from "react/compiler-runtime";
import { RateChangeType } from "./DropListItemRateGive";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { ProfileConnectedStatus } from "@/entities/IProfile";
export default function DropListItemRateGiveChangeButton(t0) {
  const $ = _c(26);
  const {
    type,
    canVote,
    handleMouseDown,
    handleMouseUp,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const {
    connectionStatus
  } = useContext(AuthContext);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [RateChangeType.INCREASE]: "M18 15L12 9L6 15",
      [RateChangeType.DECREASE]: "M6 9L12 15L18 9"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const svgpaths = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      [RateChangeType.INCREASE]: "Choose positive votes",
      [RateChangeType.DECREASE]: "Decrease vote"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const ariaLabels = t3;
  let t4;
  if ($[2] !== connectionStatus || $[3] !== handleMouseDown || $[4] !== type) {
    t4 = () => {
      if (connectionStatus !== ProfileConnectedStatus.HAVE_PROFILE) {
        return;
      }
      handleMouseDown(type);
    };
    $[2] = connectionStatus;
    $[3] = handleMouseDown;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onMouseDown = t4;
  let t5;
  if ($[6] !== connectionStatus || $[7] !== handleMouseUp) {
    t5 = () => {
      if (connectionStatus !== ProfileConnectedStatus.HAVE_PROFILE) {
        return;
      }
      handleMouseUp();
    };
    $[6] = connectionStatus;
    $[7] = handleMouseUp;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onMouseUpOrLeave = t5;
  const getButtonClasses = _temp;
  const buttonClasses = getButtonClasses(canVote);
  let t6;
  if ($[9] !== onMouseDown) {
    t6 = e => {
      e.stopPropagation();
      onMouseDown();
    };
    $[9] = onMouseDown;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onMouseUpOrLeave) {
    t7 = e_0 => {
      e_0.stopPropagation();
      onMouseUpOrLeave();
    };
    $[11] = onMouseUpOrLeave;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !canVote;
  const t9 = ariaLabels[type];
  const t10 = `tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-text-iron-300 tw-ring-1 tw-ring-iron-700/50 tw-transition-all tw-duration-300 ${isMobile ? "tw-size-10 tw-bg-iron-800 active:tw-scale-95 active:tw-bg-iron-600" : "tw-size-6 tw-bg-iron-900 hover:tw-bg-iron-800 hover:tw-text-iron-200 hover:tw-ring-iron-600/50"} tw-transition-all tw-duration-150 ${buttonClasses}`;
  const t11 = `${isMobile ? "tw-size-6" : "tw-size-4"} tw-flex-shrink-0 tw-rotate-90`;
  const t12 = svgpaths[type];
  let t13;
  if ($[13] !== t12) {
    t13 = <path d={t12} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t11 || $[16] !== t13) {
    t14 = <svg className={t11} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t13}</svg>;
    $[15] = t11;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== onMouseUpOrLeave || $[19] !== t10 || $[20] !== t14 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t15 = <button type="button" onMouseDown={t6} onMouseUp={t7} onMouseLeave={onMouseUpOrLeave} onClick={_temp2} disabled={t8} aria-label={t9} className={t10}>{t14}</button>;
    $[18] = onMouseUpOrLeave;
    $[19] = t10;
    $[20] = t14;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}
function _temp(ratingAllowed) {
  if (ratingAllowed) {
    return "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-text-iron-300";
  }
  return "tw-text-iron-500";
}